import React from 'react'
import moment from 'moment-timezone'
import { Progress } from 'reactstrap';
import {makeStyles, Chip, useTheme} from '@material-ui/core'
import { isUndefined } from 'lodash';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import {useSelector} from 'react-redux'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const useStyles = makeStyles({
  MainProgress: {
    backgroundColor: '#09585C80 !important',
    height:"100% !important",
    borderRadius:"0"
  }
});

function ProgressItem({intl,type, total, endSum, leadingValue, classes, intervalltype, _index, tag, compFinished, Keyword, Color}) {

  const formatNumber=(number)=>{
    if(number > 1000000){
        return `${(number/1000).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}K`
    }else if(number >= 1000){
        return `${(number/1000).toFixed(0)}K`
    }else{
        return number
    }
  }

  const returnValueProgress = (value) => {
    return (value/parseInt(endSum)) * 100 > 100 ? 100 : (value/parseInt(endSum)) * 100
  }

  const returnProgressClass = (value) => {
    if(value > 90) return classes.prog90
    if(value > 50) return classes.prog50
    if(value > 30) return classes.prog30
    return classes.prog30
  }

  const getTag = () => {
    return <Chip label={Keyword} style={{['-webkit-text-stroke']: '0px #fff', backgroundColor: Color, color:'#fff', marginBottom: 6, fontSize: 17}} size="large" />
  }

  const returnValueFormatByTypeTotal = () => {
    switch(type) {
      //Försäljning
      case 1: return formatNumber(endSum)
      //Bokade möten
      case 2: return `${endSum} ${intl.formatMessage({ id: 'DashBoard.contest.Book.Short' })}`
      //Taggar
      case 3: return <>{`${endSum} `}{getTag()}</>
      //Aktiviteter
      case 4: return `${endSum} ${intl.formatMessage({ id: 'Activities' })}`
      default: return endSum
    }
  }

  return (
    <div className='w-100 overflow-hidden'
      style={{height: 50}}
    >
      <div className='d-flex align-items-center justify-content-center h-100 w-100' style={{height: 110}}>
      <h1 className='m-0' style={
        {
          fontSize: 26, fontWeight: 700,
          color: 'rgb(68, 209, 194)',
          ['-webkit-text-stroke']: '2px rgb(84, 243, 227)'
          }}>
            {returnValueFormatByTypeTotal()}
        </h1>
      </div>
    </div>
  )
}

function CountDownComponent(props) {
  const classes = useStyles()
  const theme = useTheme();

  const [time, setTime] = React.useState('00:00:00')
  const [timeObj, setTimeObj] = React.useState({
    seconds: 0,
    minutes: 0,
    hours: 0,
    days: 0,
  })
  const [progress, setProgress] = React.useState(0)

  const [activeStep, setActiveStep] = React.useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const setTimeFunc = () => {
    let diff = moment(props.Competition.compEnd).diff(moment())
    let hasStarted = moment().diff(props.Competition.compStart) > 0
    if(!hasStarted) diff = moment(props.Competition.compEnd).diff(moment(props.Competition.compStart))

    if(hasStarted) {
      let diff2 = moment(props.Competition.compEnd).diff(moment(props.Competition.compStart))
      // console.log(100 - ((diff / diff2) * 100))
      setProgress(100 - ((diff / diff2) * 100))
    }

    let duration = moment.duration(diff, 'millisecond')
    // console.log(duration)

    let hours = duration.hours().toString()
    hours = hours.length <= 1 ? '0'+hours : hours

    let minutes = duration.minutes().toString()
    minutes = minutes.length <= 1 ? '0'+minutes : minutes

    let seconds = duration.seconds().toString()
     seconds = seconds.length <= 1 ? '0'+seconds : seconds

     let days = (duration.days() + (duration.months() * 30) + (duration.years() * 365)).toString()
     days = days <= '0' ? '0:' : `${days}:`

    if(diff > 0)  {
      setTime(`${days}${hours}:${minutes}:${seconds}`)
      setTimeObj({seconds,minutes,hours,days:String(days).replace(/:/g,'')})
    }
  }
  const formatNumber=(number)=>{
    if(number > 1000000){
        return `${(number/1000).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}K`
    }else if(number >= 1000){
        return `${(number/1000).toFixed(0)}K`
    }else{
        return number
    }
  }

  React.useEffect(() => {
    setTimeFunc()
    let interval = null;
    interval = setInterval(() => {
      setTimeFunc()
    }, 1000);
    
    return () => clearInterval(interval);
  },[props.Competition])
  if(props.Competition.compFinished) return (
    <div className='d-flex align-items-center justify-content-center h-100 w-100'>
      <h1 className='m-0' style={{
        fontSize: 26, 
        fontWeight: 700,
        color: 'rgb(68, 209, 194)',
        ['-webkit-text-stroke']: '2px rgb(84, 243, 227)'
        }}><IntlMessages id="DashBoard.Closed"/>!</h1>
    </div>
  )
  if(props.Competition.intervalltype === 2) return (
    <div className='w-100' style={{position: 'absolute', bottom: 0, left: 0}}>
      <AutoPlaySwipeableViews
          disabled
          interval={5000}
          axis={theme.direction === 'rtl' ? 'y-reverse' : 'y'}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
          className='w-100'
          style={{height: 50, position: 'relative'}}
          containerStyle={{height: 50}}
        >
          {
            props.Competition.grpData.map((d, _index) => (
            <ProgressItem 
              {...d}
              intl={props.intl}
              _index={_index}
              compFinished={props.Competition.compFinished}
              intervalltype={props.Competition.intervalltype}
              classes={classes}
            />
          ))}
        </AutoPlaySwipeableViews>
    </div>
  )
  
  return (
    <>
    <div className='position-absolute h-100 w-100' style={{zIndex: -1}}>
      <Progress multi className={classes.MainProgress}>
        <Progress bar animated 
          color={"#4bc3c5"}
          value={progress} 
          max={100}
        >
        </Progress>
      </Progress>
    </div>

    <div className='d-flex align-items-center justify-content-around h-100 w-100 px-1'>
      {/* <div className='d-flex align-items-center flex-column'> */}
        <h1 className='text-white m-0' style={{fontSize: "140%", fontWeight: 700}}>{timeObj.days}</h1>
        {/* <small style={{fontSize: '1rem', fontWeight: 500}}><IntlMessages id={"Days"} /></small> */}
      {/* </div> */}
      <h1 className='text-white m-0' style={{fontSize: "140%", fontWeight: 700}}>:</h1>
      {/* <div className='d-flex align-items-center flex-column'> */}
        <h1 className='text-white m-0' style={{fontSize: "140%", fontWeight: 700}}>{timeObj.hours}</h1>
        {/* <small style={{fontSize: '1rem', fontWeight: 500}}><IntlMessages id="Times"/></small> */}
      {/* </div> */}
      <h1 className='text-white m-0' style={{fontSize: "140%", fontWeight: 700}}>:</h1>
      {/* <div className='d-flex align-items-center flex-column'> */}
        <h1 className='text-white m-0' style={{fontSize: "140%", fontWeight: 700}}>{timeObj.minutes}</h1>
        {/* <small style={{fontSize: '1rem', fontWeight: 500}}>minuter</small> */}
      {/* </div> */}
      <h1 className='text-white m-0' style={{fontSize: "140%", fontWeight: 700}}>:</h1>
      {/* <div className='d-flex align-items-center flex-column'> */}
        <h1 className='text-white m-0' style={{fontSize: "140%", fontWeight: 700}}>{timeObj.seconds}</h1>
        {/* <small style={{fontSize: '1rem', fontWeight: 500}}>sekunder</small> */}
      {/* </div> */}
      {/* <h1 className='m-0 text-white' style={{fontSize: 65, fontWeight: 700}}>{time}</h1> */}
    </div>
    </>
  )
}


export default injectIntl(CountDownComponent);